import { render, staticRenderFns } from "./ManageStaffingAssignments.vue?vue&type=template&id=6f8d4018"
import script from "./ManageStaffingAssignments.vue?vue&type=script&lang=js"
export * from "./ManageStaffingAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports